<!--
/*******************************************************************************
*@ 컴포넌트명   : DepositNewSummary.vue
*@ 컴포넌트설명 : 예금신규 Summary
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div class="dropdown-field" @click="openData = !openData">
    <div class="section">
      <span v-html="prdctName"></span>
      <i class="icon icon-list" v-if="!openData" />
      <i class="icon icon-dropdown-arrow" v-if="openData" :class="{ rotate180: openData }" />
    </div>
    <div class="dropdown-field--list" v-if="openData">
      <div class="list-item">
        <div class="tit">{{ /*상품 정보*/ $t("MDEP-01-01-14-02") }}</div>
        <div class="dec" v-html="prdctBrifCtnt"></div>
      </div>
      <div class="list-item">
        <div class="tit">{{ /*금리 및 이율*/ $t("MDEP-01-01-14-04") }}</div>
        <div class="dec">
          <!-- <p v-html="prdctIrtBrifCtnt" /> -->
          <p
            v-for="(item, i) in g002_dpsNV.tSRCAPR14List"
            :key="i"
            v-html="item.joinCncycd + ' : ' + (lang === 'KOR' ? item.irtIrtHanglCtnt : lang === 'ENG' ? item.irtIrtEngCtnt : item.irtIrtLcalCtnt)"
          ></p>
        </div>
      </div>
      <div class="list-item" v-if="step >= 1 || step == 0">
        <div class="tit">{{ /*통화 종류*/ $t("MDEP-01-01-14-05") }}</div>
        <div class="dec">
          <p>{{ depositNewReqInfo.cncycd }}</p>
        </div>
      </div>
      <div class="list-item" v-if="step >= 1 || step == 0">
        <div class="tit">{{ /*가입 금액*/ $t("MDEP-01-01-14-06") }}</div>
        <div class="dec">
          <p v-html="$num(depositNewReqInfo.dpostBal, null, true)"></p>
        </div>
      </div>
      <div class="list-item" v-if="step >= 1 || step == 0">
        <div class="tit">{{ /*가입 기간*/ $t("MDEP-01-01-14-07") }}</div>
        <div class="dec">
          <p>{{ depositNewReqInfo.indpCnpr.ctrcTrmCnt }} {{ $t($ctrcUnitDstcdType(depositNewReqInfo.indpCnpr.ctrcTrmUnitDstic)) }}</p>
        </div>
      </div>
      <div class="list-item" v-if="(step >= 2 || step == 0) && depositNewReqInfo.isStpulCfm">
        <div class="tit">{{ /*약관 동의*/ $t("MDEP-01-01-14-09") }}</div>
        <div class="dec">
          <p>{{ /*동의함*/ $t("MDEP-01-01-14-10") }}</p>
        </div>
      </div>
      <div class="list-item" v-if="step >= 3">
        <div class="tit">{{ /*출금계좌*/ $t("MDEP-01-01-14-11") }}</div>
        <div class="dec">
          <p>{{ depositNewReqInfo.accountingCommon.cupldAcno }}</p>
        </div>
      </div>
      <div class="list-item" v-if="step >= 3 && g002_strBrncoPrdctCd != '1102'">
        <div class="tit">{{ /*자동이체 계좌*/ $t("MDEP-01-01-14-12") }}</div>
        <div class="dec">
          <p>{{ depositNewReqInfo.lnkgAcno }}</p>
        </div>
      </div>
      <div class="list-item" v-if="step >= 4">
        <div class="tit">{{ /*만기후 처리*/ $t("MDEP-01-01-16-12") }}</div>
        <div class="dec">
          <p>{{ $t(`${depositNewReqInfo.autoExpirExtenYn}_예금만기후처리`) }}</p>
        </div>
      </div>
      <div class="list-item" v-if="step >= 4 && depositNewReqInfo.expirExtenFormDstcd">
        <div class="tit">{{ /*자동연장 금액*/ $t("MDEP-01-01-16-13") }}</div>
        <div class="dec">
          <p>{{ depositNewReqInfo.expirExtenFormDstcd == '1' ? /*원금*/ $t("MDEP-01-01-13-09") : /*원금+이자*/ $t("MDEP-01-01-13-10") }}</p>
        </div>
      </div>
      <div class="list-item" v-if="step >= 4 && depositNewReqInfo.brncoIntPaymtCyclDstcd">
        <div class="tit">{{ /*이자 지급 방식*/ $t("MDEP-01-01-13-13") }}</div>
        <div class="dec">
          <p>{{ depositNewReqInfo.brncoIntPaymtCyclDstcd == '0' ? /*만기지급식*/ $t("MDEP-01-01-13-14") : /*월이자지급식*/ $t("MDEP-01-01-13-15") }}</p>
        </div>
      </div>
      <div
        class="list-item"
        v-if="step >= 4 && g002_strBrncoPrdctCd == '1102' && depositNewReqInfo.lnkgAcno"
      >
        <div class="tit">{{ /*연결계좌번호*/ $t("MDEP-01-01-13-16") }}</div>
        <div class="dec">
          <p>{{ depositNewReqInfo.lnkgAcno }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";

export default {
  props: {
    opened: {
      type: Boolean,
      required: true,
    },
    step: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapFields(["lang"]),
    ...mapFields("deposit/depositNewReq", ["depositNewReqInfo"]),
    ...mapGetters("deposit/manageDeposit", ["g002_dpsNV"]),
    ...mapGetters("deposit/manageDeposit", ["g002_strBrncoPrdctCd"]),
    prdctName: {
      get() {
        if (this.lang == this.$config.LANG_KOR) {
          return this.g002_dpsNV.tSRCAPR11Detail.prdctHanglName;
        } else if (this.lang == this.$config.LANG_ENG) {
          return this.g002_dpsNV.tSRCAPR11Detail.prdctEngName;
        } else {
          return this.g002_dpsNV.tSRCAPR11Detail.ovsesPrdctLcalName;
        }
      },
    },
    prdctBrifCtnt: {
      get() {
        if (this.lang == this.$config.LANG_KOR) {
          return this.g002_dpsNV.tSRCAPR11Detail.prdctBrifHanglCtnt;
        } else if (this.lang == this.$config.LANG_ENG) {
          return this.g002_dpsNV.tSRCAPR11Detail.prdctBrifEngCtnt;
        } else {
          return this.g002_dpsNV.tSRCAPR11Detail.prdctBrifLcalCtnt;
        }
      },
    },
    openData: {
      get() {
        return this.opened;
      },
      set(value) {
        this.$emit("update:opened", value);
      },
    },
    stepData: {
      get() {
        return this.step;
      },
    },
  },
};
</script>